export function isEmail(asValue) {
	const regExp =
		/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
	return regExp.test(asValue);
}

// 비밀번호 정책 : 문자 종류 제한 없이 6자 이상
export const PASSWORD_REGEX = /^.{6,}$/;

export function isPassword(pw) {
	return PASSWORD_REGEX.test(pw || '');
}

export function isTel(asValue) {
	const regExp = /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/g;
	return regExp.test(asValue);
}

export function isPhone(asValue) {
	const regExp = /^01([0|1|6|7|8|9]?)?([0-9]{3,4})?([0-9]{4})$/g;
	return regExp.test(asValue);
}
